import { TEmojiId, TPeerAction } from '@src/types';

export const ADJECTIVES = [
  'small',
  'big',
  'large',
  'smelly',
  'new',
  'happy',
  'shiny',
  'old',
  'clean',
  'nice',
  'bad',
  'cool',
  'hot',
  'cold',
  'warm',
  'hungry',
  'slow',
  'fast',
  'red',
  'white',
  'black',
  'blue',
  'green',
  'basic',
  'strong',
  'cute',
  'poor',
  'nice',
  'huge',
  'rare',
  'lucky',
  'weak',
  'tall',
  'short',
  'tiny',
  'great',
  'long',
  'single',
  'rich',
  'young',
  'dirty',
  'fresh',
  'brown',
  'dark',
  'crazy',
  'sad',
  'loud',
  'brave',
  'calm',
  'silly',
  'smart',
];

export const NOUNS = [
  'dog',
  'bat',
  'wrench',
  'apple',
  'pear',
  'ghost',
  'cat',
  'wolf',
  'squid',
  'goat',
  'snail',
  'hat',
  'sock',
  'plum',
  'bear',
  'snake',
  'turtle',
  'horse',
  'spoon',
  'fork',
  'spider',
  'tree',
  'chair',
  'table',
  'couch',
  'towel',
  'panda',
  'bread',
  'grape',
  'cake',
  'brick',
  'rat',
  'mouse',
  'bird',
  'oven',
  'phone',
  'photo',
  'frog',
  'bear',
  'camel',
  'sheep',
  'shark',
  'tiger',
  'zebra',
  'duck',
  'eagle',
  'fish',
  'kitten',
  'lobster',
  'monkey',
  'owl',
  'puppy',
  'pig',
  'rabbit',
  'fox',
  'whale',
  'beaver',
  'gorilla',
  'lizard',
  'parrot',
  'sloth',
  'swan',
];

export const BRAND = {
  app: {
    name: 'Meet',
    title: 'MiroTalk SFU<br />Free browser based Real-time video calls.<br />Simple, Secure, Fast.',
    description:
      'Start your next video call with a single click. No download, plug-in, or login is required. Just get straight to talking, messaging, and sharing your screen.',
  },
  site: {
    title: 'MiroTalk SFU, Free Video Calls, Messaging and Screen Sharing',
    icon: '../images/logo.svg',
    appleTouchIcon: '../images/logo.svg',
  },
  meta: {
    description:
      'MiroTalk SFU powered by WebRTC and mediasoup, Real-time Simple Secure Fast video calls, messaging and screen sharing capabilities in the browser.',
    keywords:
      'webrtc, miro, mediasoup, mediasoup-client, self hosted, voip, sip, real-time communications, chat, messaging, meet, webrtc stun, webrtc turn, webrtc p2p, webrtc sfu, video meeting, video chat, video conference, multi video chat, multi video conference, peer to peer, p2p, sfu, rtc, alternative to, zoom, microsoft teams, google meet, jitsi, meeting',
  },
  og: {
    type: 'app-webrtc',
    siteName: 'MiroTalk SFU',
    title: 'Click the link to make a call.',
    description: 'MiroTalk SFU calling provides real-time video calls, messaging and screen sharing.',
    image: 'https://sfu.mirotalk.com/images/mirotalksfu.png',
    url: 'https://sfu.mirotalk.com',
  },
  html: {
    features: true,
    teams: true,
    tryEasier: true,
    poweredBy: true,
    sponsors: true,
    advertisers: true,
    footer: true,
  },
  //...
};

// HeyGen config
export const VIDEO_AI = {
  enabled: true,
  active: false,
  info: {},
  avatarId: null,
  avatarName: 'Monica',
  avatarVoice: null,
  quality: 'medium',
  virtualBackground: true,
  background: '../images/virtual/1.jpg',
};

export const survey = {
  enabled: true,
  url: 'https://www.questionpro.com/t/AUs7VZq02P',
};

export const redirect = {
  enabled: true,
  url: '/newroom',
};

export const _PEER = {
  presenter: '<i class="fa-solid fa-user-shield"></i>',
  guest: '<i class="fa-solid fa-signal"></i>',
  audioOn: '<i class="fas fa-microphone"></i>',
  audioOff: '<i class="fas fa-microphone-slash red"></i>',
  videoOn: '<i class="fas fa-video"></i>',
  videoOff: '<i class="fas fa-video-slash red"></i>',
  screenOn: '<i class="fas fa-desktop"></i>',
  screenOff: '<i class="fas fa-desktop red"></i>',
  raiseHand: '<i style="color: rgb(0, 255, 71);" class="fas fa-hand-paper pulsate"></i>',
  lowerHand: '',
  acceptPeer: '<i class="fas fa-check"></i>',
  banPeer: '<i class="fas fa-ban red"></i>',
  ejectPeer: '<i class="fas fa-right-from-bracket red"></i>',
  geoLocation: '<i class="fas fa-location-dot"></i>',
  sendFile: '<i class="fas fa-upload"></i>',
  sendMsg: '<i class="fas fa-paper-plane"></i>',
  sendVideo: '<i class="fab fa-youtube"></i>',
};

export const MAX_BOXES = 16;

export const MAX_MOBILE_BOXES = 6;

export const CONTAINER_MARGIN = 8;

export const REACTIONS: TEmojiId[] = [
  'heart',
  'thumbsUp',
  'clap',
  'party',
  'monocle',
  'surprised',
  'tearsOfJoy',
  'cryingFace',
  'thumbsDown',
];

export const MEETING_ENDED = {
  MEETING_SESSION_ENDED: 'MEETING_SESSION_TIMEOUT',
  MEETING_ENDED_BY_HOST: 'HOST_OR_COHOST_CLOSED_SESSION',
};
